export let TRELLO_LOGO =
  "https://upload.wikimedia.org/wikipedia/en/thumb/8/8c/Trello_logo.svg/1280px-Trello_logo.svg.png";

export let DummyData = [
  {
    id: 1,
    title: "Morning Walk",
    description: "Walk for 15 min in park",
    list: "todo",
  },
  {
    id: 2,
    title: "Evening Walk",
    description: "Walk for 15 min in park",
    list: "inprogress",
  },
  {
    id: 3,
    title: "Coding Challenge",
    description: "Code 1 hour daily in leetcode",
    list: "done",
  },
  {
    id: 4,
    title: "Client Meet",
    description: "show process of project till & discussion",
    list: "todo",
  },
];

export const datas = {
  data: [
    {
      todo: [
        {
          id: 1,
          title: "Morning Walk",
          description: "Walk for 15 min in park",
          list: "todo",
        },
        {
          id: 4,
          title: "Client Meet",
          description: "show process of project till & discussion",
          list: "todo",
        },
      ],
      inprocess: [
        {
          id: 2,
          title: "Evening Walk",
          description: "Walk for 15 min in park",
          list: "inprogress",
        },
      ],
      done: [
        {
          id: 3,
          title: "Coding Challenge",
          description: "Code 1 hour daily in leetcode",
          list: "done",
        },
      ],
    },
  ],
};
